/**
 * Aftersale Humanize Date
 * @param date
 */
export function aftersaleHumanizeDate(date: number) {
    const diff = (date.toString().length === 13 ? date : date * 1000) - Date.now();

    let day = Math.floor(diff / (24 * 3600 * 1000));
    let hours = Math.ceil((diff % (24 * 3600 * 1000)) / (3600 * 1000));

    if (diff < 0) return null;

    if (hours === 24) {
        day += 1;
        hours = 0;
    }

    let res = day ? day + '天' : '';
    if (hours) {
        res += hours + '小时';
    }
    return res;
}
